import { KM_UNIT_CODE } from '@/modern/components/Seo/schemas/constants'

export function isValidVehicleData(ad) {
  return Boolean(ad?.Specification?.Model?.Value)
}

export function parseYear(year) {
  const parsedYear = Number.parseInt(year, 10)
  return Number.isFinite(parsedYear) ? `${parsedYear}` : undefined
}

export function buildMileageFromOdometer(mileageValue) {
  return Number.isFinite(mileageValue)
    ? {
        '@type': 'QuantitativeValue',
        value: mileageValue,
        unitCode: KM_UNIT_CODE,
      }
    : undefined
}
